import { render, staticRenderFns } from "./entity-payment-status.vue?vue&type=template&id=bff63d02&scoped=true"
import script from "./entity-payment-status.vue?vue&type=script&lang=js"
export * from "./entity-payment-status.vue?vue&type=script&lang=js"
import style0 from "./entity-payment-status.vue?vue&type=style&index=0&id=bff63d02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff63d02",
  null
  
)

export default component.exports